
export const humanFriendlyDate = (dateStr: string) => {
	const timestamp = Date.parse(dateStr);
	if (Number.isNaN(timestamp)) {
		return undefined;
	}
	const d = new Date(Date.parse(dateStr));
	return d.toLocaleDateString();
};
